import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from "../contexts/auth";
import { getCustomersURL } from '../utils/api';

const useGetCustomers = ({ 
        page = 1,
        limit = 3000,
        keyword, 
        plateKeyword, 
        setErrors
    }) => {
        
    const { auth } = useAuth();
    const [ gettingCustomers, setGettingCustomers ] = useState(false);
    const [ customers, setCustomers ] = useState([]);
    const [ totalCustomers, setTotalCustomers ] = useState(0);
    const [ gettingCustomersReqSuccess, setGettingCustomersReqSuccess ] = useState(false);
    
    useEffect(() => {

        if (gettingCustomers) {

            if (keyword) keyword = encodeURIComponent(keyword);
            if (plateKeyword) plateKeyword = encodeURIComponent(plateKeyword);

            axios.get(getCustomersURL, 
            {
                headers: {
                    Authorization: `Bearer ${auth.authToken}`
                },
                params: {
                    page,
                    limit,
                    keyword: keyword,
                    plateKeyword: plateKeyword, 
                }
            }).then(result => {
                setGettingCustomers(false);
                if (result.status === 200) {
                    const data = result.data.data;
                    if (result.data.total) {
                        setTotalCustomers(result.data.total);
                    }
                    setGettingCustomersReqSuccess(true);
                    setCustomers(data);         
                } else {
                    // console.log(result.data.errors);
                    if (setErrors) {
                        setErrors(result.data.errors);
                    }
                    setGettingCustomersReqSuccess(false);
                    // setOperatorAddErrors(result.data.errors);
                }
            }).catch(e => {
                if (e.response === undefined) {
                    // console.log(e);
                    if (setErrors) {
                        setErrors(['Could not connect to server']);
                    }
                    // setOperatorAddErrors(['Could not connect to server!'])
                } else {
                    // console.log(e.response.data.errors);
                    // setOperatorAddErrors(e.response.data.errors)
                    if (setErrors) {
                        setErrors([e.response.data.errors]);
                    }
                }
                setGettingCustomersReqSuccess(false);
                setGettingCustomers(false);
            });
        }
    }, [gettingCustomers]);

    return { customers, totalCustomers, gettingCustomers, setGettingCustomers, gettingCustomersReqSuccess };
}

export default useGetCustomers;